import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="bg-[#001F3F] text-white mt-auto">
      <div className="w-[90%] md:w-[80%] mx-auto py-4">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm">
          <Link to="/about" className="text-gray-300 hover:text-[#D4AF37] transition-colors">À propos</Link>
          <Link to="/guide" className="text-gray-300 hover:text-[#D4AF37] transition-colors">Mode d'Emplois</Link>
          <Link to="/help" className="text-gray-300 hover:text-[#D4AF37] transition-colors">Aide</Link>
          <Link to="/privacy" className="text-gray-300 hover:text-[#D4AF37] transition-colors">Confidentialité</Link>
          <Link to="/terms" className="text-gray-300 hover:text-[#D4AF37] transition-colors">Conditions</Link>
          <span className="text-gray-300">Français ▼</span>
          <span className="text-gray-400">© 2024 KUDHI by Unloader Technologies</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
